// @ts-strict-ignore
import * as React from 'react';
import clsx from 'clsx';
import { Typography } from 'onboarding-components';
import { SvgIconReact } from 'common/components/svg-icon';
import { Trans } from 'common/i18n';
import { useTranslation } from 'common/i18n/hooks';
import { HelpTextType } from '../types';
import styles from './index.module.styl';

/* eslint-disable react/destructuring-assignment */
export const HelpText = (_ref: {
  type?: HelpTextType;
  children?: React.ReactNode;
  animationTrigger?: {
    bounceInput: boolean;
  };
}) => {
  let {
    type,
    children,
    animationTrigger
  }: {
    type?: HelpTextType;
    children?: React.ReactNode;
    animationTrigger?: {
      bounceInput: boolean;
    };
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    bounceInput
  } = animationTrigger;
  return <div className={clsx(styles.helpTextContainer, {
    [styles.bounce]: bounceInput
  })} data-sentry-component="HelpText" data-sentry-source-file="help-text.tsx">
      <div className={clsx(styles.helpText, {
      [styles.show]: type === "edit-property"
    })}>
        <SvgIconReact icon='note' data-sentry-element="SvgIconReact" data-sentry-source-file="help-text.tsx" />
        <Typography variant='bodySm' className={styles.propertiesHelpText} data-sentry-element="Typography" data-sentry-source-file="help-text.tsx">
          <Trans i18nKey={"onboarding.events.property-help-text"} t={t} components={{
          boldText: <span className={styles.bold} />
        }} data-sentry-element="Trans" data-sentry-source-file="help-text.tsx" />
        </Typography>
      </div>
      <div className={clsx(styles.helpText, {
      [styles.show]: type === "event"
    })}>
        {children}
        <Typography variant='bodySm' data-sentry-element="Typography" data-sentry-source-file="help-text.tsx">
          <Trans i18nKey={"onboarding.events.event-help-text"} t={t} components={{
          boldText: <span className={styles.bold} />
        }} data-sentry-element="Trans" data-sentry-source-file="help-text.tsx" />
        </Typography>
      </div>
      <div className={clsx(styles.helpText, {
      [styles.show]: type === "select-property"
    })}>
        {children}
        <Typography variant='bodySm' data-sentry-element="Typography" data-sentry-source-file="help-text.tsx">
          <Trans i18nKey={"onboarding.events.select-property-help-text"} t={t} components={{
          boldText: <span className={styles.bold} />
        }} data-sentry-element="Trans" data-sentry-source-file="help-text.tsx" />
        </Typography>
      </div>
    </div>;
};